var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, Typography } from "@mui/material";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { CardCertidaoBaixa } from "../../components/Veiculos/CardCertidaoBaixa";
import { InfoVeiculo } from "../../components/Veiculos/InfoVeiculo";
export var CertidaoBaixa = function () {
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "Certid\u00E3o de Baixa Definitiva", goBackTo: "/veiculos/certidao-baixa" }), _jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsx(InfoVeiculo, {}), _jsx(Typography, __assign({ variant: "h5", fontSize: "1.375rem", fontWeight: "500", mb: "1rem" }, { children: "Certid\u00F5es:" })), _jsx(Divider, { sx: { mb: "1rem" } }), _jsx(CardCertidaoBaixa, {})] }) }))] }));
};
